import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from 'actions'
import SelectSuspension from 'components/site/select_suspension'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectSuspension: state.searchFormCondition.selectSuspension,
})

const SelectSuspensionContainer = connect(mapStateToProps, mapDispatchToProps)(SelectSuspension)

export default SelectSuspensionContainer
